// environment settings that are used when the CI deploys to the prod environment
import { Environment } from './types';

export const environment: Environment = {
  production: true,
  name: 'prod',
  sentry: {
    enabled: true,
    showDialog: false,
  },
  sessionServer: 'soulmachines.cloud',
  deploymentSubdomains: [
    {
      name: 'Default',
      subdomain: 'dh',
    },
    {
      name: 'Azure',
      subdomain: 'dh.az',
    },
  ],
  apiConfig: {
    url: 'https://config-service.soulmachines.cloud/api/v1',
  },
  apiOrg: {
    url: 'https://entity-service.soulmachines.cloud/api/v1',
    urlV2: 'https://entity-service.soulmachines.cloud/api/v2',
  },
  apiDesigner: {
    version: '2.4',
  },
  auth0Config: {
    audience: 'https://api.studio.soulmachines.cloud',
    domain: 'authenticate-studio.soulmachines.cloud',
    clientId: 'oXPjLWLtKIamyMFDTnpwXuKx1X2uVEfI',
  },
  analytics: {
    url: 'https://analytics-service.soulmachines.cloud/api/v1',
  },
  soulMachinesOrgId: 1,
  featureFlags: {
    'project-interactive-preview': true,
    'project-preview-speech-logging': false,
    'blender-stylized-mode': false,
    'insights-conversation-nodes': true,
    'manage-skills-form': true,
    'project-legal-agreements': false,
    'project-knowledge': true,
    'dashboard-conversation-count-usage-indicator': false,
    'navbar-organization-menu': true,
    'user-notification-receipt': false,
    'dashboard-usage-indicators': true,
    'admin-notification-contents': true,
    'project-sidebar-validation': true,
  },
  segment: {
    writeKey: '',
  },
  posthog: {
    apiKey: 'phc_njB6owfzxxJcs8oEU2rhNZFTpcaQ3yinyAVXVapZgQ26',
    apiHost: 'https://us.i.posthog.com',
    app_release: 'ddna-studio@prod',
  },
  projectThemes: [{ text: 'auckland-sales-theme_stable', value: 'auckland-sales-theme_stable' }],
  gtmId: 'GTM-PNDSTWH',
};
